import { useSelector } from "react-redux"
import queryString from "query-string"
import { ADDITIONAL_COURSE_ID } from "../Constants/courses"

// TODO: get the filters into their own hook for cohesion

// commenting out because COMMIT might change ideas about
// competitive tier DL access
// const tierFilter = user => navOption => {
//   return {
//     ...navOption,
//     toDisplay: user.competitive_tier > -1 || navOption.usi === "logout"
//   }
// }

const homeFilter = (user) => (navOption) => {
  if (navOption.usi === "home") {
    if (user.has_submitted_application && user.competitive_tier > -1) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const pypFilter = (user) => (navOption) => {
  if (navOption.usi === "pyp") {
    if (
      user.programs &&
      user.programs.some(
        (program) =>
          program.name === "Pursue Your Purpose" &&
          program.pivot.status === "approved"
      ) &&
      process.env.REACT_APP_PYP_ENABLED !== "false"
    ) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const spouse_filter = (user, workshops) => (navOption) => {
  if (navOption.usi === "spouseCourse") {
    if (workshops.length) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const networkFilter = (user) => (navOption) => {
  if (navOption.usi === "network") {
    if (
      user.programs &&
      user.programs.some(
        (program) =>
          program.name === "Network" && program.pivot.status === "approved"
      ) &&
      user.community &&
      user.community.community_member === 1 &&
      user.linkedin_url
    ) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const digitalLibraryFilter = (user) => (navOption) => {
  if (navOption.usi === "digitalLibrary") {
    if (
      user.programs &&
      user.programs.some(
        (program) =>
          program.name === "Digital Library" &&
          program.pivot.status === "approved"
      ) &&
      process.env.REACT_APP_DL_ENABLED !== "false"
    ) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const additionalCourseFilter = (user) => (navOption) => {
  if (navOption.usi === "additionalCourse") {
    if (
      user.enrolled_courses &&
      user.enrolled_courses.some((c) => Number(c.id) === ADDITIONAL_COURSE_ID)
    ) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    toDisplay: navOption.toDisplay
  }
}

const analyticsFilter = (user) => (navOption) => {
  if (navOption && navOption.usi === "analytics") {
    if (user.role && user.role.id === 1) {
      return {
        ...navOption,
        toDisplay: true
      }
    }
    return {
      ...navOption,
      toDisplay: false
    }
  }
  return {
    ...navOption,
    ntoDisplay: navOption.toDisplay
  }
}

const runFilledMiddleware = (...funcs) => {
  return (value) => {
    return funcs.reduceRight((acc, func) => {
      return acc.map(func)
    }, value)
  }
}

const useNavOptions = (match, location = {}) => {
  const { user, workshops, currentCourseIdFromRedux } = useSelector((state) => ({
    user: state.user.user,
    workshops: state.workshop?.workshops,
    currentCourseIdFromRedux: state.pyp.navigation.currentCourseId
  }))

  const additionalCourse = user?.enrolled_courses?.find(
    (c) => Number(c.id) === ADDITIONAL_COURSE_ID
  )
  const additionalCourseName = additionalCourse?.name || "Course"

  const onWorkshop = /workshop/.test(match.path)
  const queryCourseId = queryString.parse(location.search || "").courseId
    ? Number(queryString.parse(location.search || "").courseId)
    : null
  const activeCourseId = onWorkshop
    ? queryCourseId ??
      (currentCourseIdFromRedux > -1 ? currentCourseIdFromRedux : null)
    : null
  const pypNavSelected =
    onWorkshop && Number(activeCourseId) !== ADDITIONAL_COURSE_ID
  const additionalNavSelected =
    onWorkshop && Number(activeCourseId) === ADDITIONAL_COURSE_ID

  const options = [
    {
      text: "Home",
      usi: "home",
      isSelected: /home/.test(match.path)
    },
    {
      text: "Workshops",
      usi: "spouseCourse",
      isSelected: /virtualcohort/.test(match.path)
    },
    {
      text: "Digital Library",
      usi: "digitalLibrary",
      isSelected: /digitalLibrary/.test(match.path)
    },
    {
      text: "Pursue Your Purpose",
      usi: "pyp",
      isSelected: pypNavSelected
    },
    {
      text: additionalCourseName,
      usi: "additionalCourse",
      isSelected: additionalNavSelected
    },
    {
      text:
        user && user.has_submitted_application
          ? "Edit Profile"
          : "Edit Application",
      usi: "editProfile",
      isSelected: /profile/.test(match.path),
      toDisplay: true
    },
    {
      text: "Analytics",
      usi: "analytics",
      isSelected: /analytics/.test(match.path),
      toDisplay: true
    },
    {
      text: "Network",
      usi: "network",
      isSelected: /network/.test(match.path),
      toDisplay: true
    },
    { text: "Logout", usi: "logout", toDisplay: true }
  ]

  const filteredOptions = runFilledMiddleware(
    pypFilter(user),
    additionalCourseFilter(user),
    homeFilter(user),
    spouse_filter(user, workshops),
    analyticsFilter(user),
    // tierFilter(user),
    digitalLibraryFilter(user),
    networkFilter(user)
  )(options)

  return filteredOptions
}

export default useNavOptions
